import { ReportingTypeEnum } from '@quadminds/shared/commons';
import { ITemperature } from '@quadminds/shared/tracking-system';
import { IDeviceIdentificationSchema } from './device-identification-schema.interface';
import { SwimlaneCriteriaMap } from './swimlane-criteria-map';
import { ITachographInformationSchema } from './tachograph-information-schema.interface';
import { ITagsSchema } from './tags-schema.interface';
import { ITripErrors, ITripServiceSchema } from './trip-schema.interface';
import { KanbanSwimlanes } from '../../enums';

export interface ITripCardSchema {
    id: string;
    vehicleLicensePlate: string;
    vehicleName?: string;
    driverPhoneNumber?: string;
    deviceIdentification?: IDeviceIdentificationSchema;
    semitrailersLicensePlates?: string[];
    accounts?: string[];
    carrierName?: string;
    tripCode: string;
    currentCheckpointName: string;
    nextCheckpoint?: string;
    currentStepName: string;
    currentStepTriggeredAt: string;
    nextStepName?: string;
    nextStepEta?: string;
    nextStepSta?: string;
    delay?: SwimlaneCriteriaMap<string, { accumDelay: string; currentCheckpointDelay?: string }>;
    state?: SwimlaneCriteriaMap<string>;
    delayInMs?: number;
    currentCheckpointNumber?: number;
    totalCheckpoints?: number;
    realStart?: string;
    realFinish?: string;
    currentStateDefinition?: string;
    currentStepPlannedAt?: string;
    isLastStep?: boolean;
    totalDuration?: string;
    totalKms?: string;
    tags?: ITagsSchema[];
    services?: ITripServiceSchema[];
    errors?: ITripErrors[];
    driverName?: string;
    reportingType: ReportingTypeEnum;
    checkpointOrders?: ITripCardOrderSchema[];
    tachographData?: ITachographInformationSchema;
    swimlane: SwimlaneCriteriaMap<KanbanSwimlanes>;
    isReporting?: boolean;
    temperature?: ITemperature;
    afterNextCheckpointName?: string;
    dwellTime?: string;
    currentCPDwellTime?: string;
    commentsCount?: number;
    currentCheckpointIsStopover?: boolean;
    currentCheckpointIsPlanned?: boolean;
}

export interface ITripCardOrderSchema {
    id: string;
    code: string;
}
